/** Formata dias fracionários com a unidade adequada -- evita mostrar "0 dias"
 * pra durações de minutos/horas (transições rápidas, ex.: cancelamento em
 * poucos minutos). Portado do mockup #MMV-2615. */
export function fmtDias(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "–";
  if (n >= 1) return `${fmt(n)} dias`;
  const totalMin = Math.round(n * 1440);
  if (totalMin <= 0) return "0m";
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return h > 0 ? `${h}h${m > 0 ? ` ${m}m` : ""}` : `${m}m`;
}

function fmt(n: number): string {
  const s = n.toFixed(1);
  return s.endsWith(".0") ? s.slice(0, -2) : s;
}

export function isoToBR(iso: string | null | undefined): string {
  if (!iso) return "–";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function parseBR(str: string): Date {
  const [d, m, y] = str.split("/");
  return new Date(`${y}-${m}-${d}`);
}
